import isNil from 'lodash/isNil';
import moment from 'moment';
import InboxFilters from 'records/InboxFilters';

// Generated from query params
interface FilterQuery {
  tagId?: string;
  folderId?: string;
  unviewedOnly?: string;
  pinnedOnly?: string;
  startDate?: string;
  endDate?: string;
  searchTerms?: string;
  viewAll?: string;
}

// creates a filters object based on a set of query params
export default function getFilters(query: FilterQuery) {
  return new InboxFilters({
    searchTerms: query.searchTerms,
    tagId: !isNil(query.tagId) ? parseInt(query.tagId) : undefined,
    folderId: !isNil(query.folderId) ? parseInt(query.folderId) : undefined,
    unviewedOnly: query.unviewedOnly === 'true',
    pinnedOnly: query.pinnedOnly === 'true',
    startDate: query.startDate ? moment(parseInt(query.startDate)) : undefined,
    endDate: query.endDate ? moment(parseInt(query.endDate)) : undefined,
    viewAll: query.viewAll === 'true',
  });
}
